import { ApiClient } from '../apiClient';

// User email/phone OTP verification (BE: /user-verification).
// The order-otp endpoints re-verify the logged-in user's CURRENT profile
// email/phone - no body - and exist for risk-band step-ups at checkout.
// All codes (profile change AND order step-up) confirm through confirmOtp.
export class VerificationService {
  constructor(private apiClient: ApiClient) {}

  async initiateOrderEmailOtp(): Promise<boolean> {
    return this.apiClient.post<boolean>('/user-verification/order-otp/email', {});
  }

  async initiateOrderPhoneOtp(): Promise<boolean> {
    return this.apiClient.post<boolean>('/user-verification/order-otp/phone', {});
  }

  // First-time (or changed) phone: sets the number on confirm.
  async startPhoneVerification(phoneNumber: string): Promise<boolean> {
    return this.apiClient.post<boolean>('/user-verification/phone', { phoneNumber });
  }

  async confirmOtp(code: string): Promise<boolean> {
    return this.apiClient.post<boolean>(`/user-verification/${encodeURIComponent(code)}`, {});
  }
}
